const getMyListLink = (storeId, catalogId, langId) => `/shop/MySavesView?URL=MySavesView&storeId=${storeId}&catalogId=${catalogId}&langId=${langId}`;

export default getMyListLink;
